define('models/StoreLocatorSearchModel',['require','underscore', 'ObjectModel','app','UrlFactory','models/StoreLocatorModel'],

    function (require,_, ObjectModel, app, UrlFactory, StoreLocatorModel)
    {

        var storeLocatorModel;

        var StoreLocatorSearchModelPrototype = {

            name: 'StoreLocatorSearchModel',
            defaults:{
                object_type:'default',
                id_object:'none',
                url:'',
                title:'',
                icon:null,
            },

            initialize: function () {
                var model = this;
                // ObjectModel constructor heritage
                ObjectModel.prototype.initialize.apply(model, arguments);

                //
                if (!this.get(this.idAttribute)) {
                    model.set(model.idAttribute, model.get('object_type')+'_'+model.get('id_object'),{silent:true});
                }
                var url = '',
                    icon = 'marker-v2',
                    id_object = model.get('id_object'),
                    object_type = model.get('object_type'),
                    city, postcode, shop,state,
                    urlName,
                    urlOptions;
                try {
                    if (object_type === 'SHOP') {
                        shop = app.getStore(id_object);
                        icon = ' icon-logo store-icon type-' + shop.getTypeId();
                        urlName = 'storeLocatorShop';
                        urlOptions = {shop: shop.get('link_rewrite')};
                    } else if (object_type === 'CITY') {
                        city = storeLocatorModel.getCity(id_object);
                        urlName = 'storeLocatorSearch';
                        urlOptions = {search: city.get('link_rewrite')};
                    } else if (object_type === 'STATE') {
                        state = storeLocatorModel.getState(id_object);
                        urlName = 'storeLocatorState';
                        urlOptions = {state: state.get('link_rewrite')};
                    } else if (object_type === 'POSTCODE') {
                        postcode = app.getPostcode(id_object),
                        city = storeLocatorModel.getCity(postcode.get('id_city'));
                        urlName = 'storeLocatorPostcode';
                        urlOptions = {
                            postcode: postcode.get('link_rewrite_seo'),
                            city: city.get('link_rewrite')
                        };
                    }
                    if(urlName){
                        url = UrlFactory.getUrl(urlName,urlOptions)
                    }
                }catch(err){
                    app.error(err);
                }
                model.set({
                    url: url,
                    icon: icon,
                    title: model.get('name'),
                });


            },
        };
        var StoreLocatorSearchModel = ObjectModel.extend(StoreLocatorSearchModelPrototype);
        StoreLocatorSearchModel.initStoreLocator = function(storeLocator){
            if(!storeLocatorModel){
                if(storeLocator){
                    storeLocatorModel = storeLocator;
                }else{
                    storeLocatorModel = new StoreLocatorModel();
                    storeLocatorModel.fetch();
                }
            }
        }

        return StoreLocatorSearchModel;
    });

